import type { ApiResponse, PaginatedData, SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import type {
	AidRecord,
	AidRecordCreateRequest,
	AidRecordUpdateRequest,
	ListAidRecordsParams,
} from "../types";

export const aidRecordsService = {
	async list(params: ListAidRecordsParams): Promise<PaginatedData<AidRecord>> {
		const response = await apiClient.get<ApiResponse<PaginatedData<AidRecord>>>("/aid-records", {
			params,
		});
		return (response.data as SuccessResponse<PaginatedData<AidRecord>>).data;
	},

	async getById(id: string): Promise<AidRecord> {
		const response = await apiClient.get<SuccessResponse<AidRecord>>(`/aid-records/${id}`);
		return response.data.data;
	},

	async create(data: AidRecordCreateRequest): Promise<AidRecord> {
		const response = await apiClient.post<SuccessResponse<AidRecord>>("/aid-records", data);
		return response.data.data;
	},

	async update(id: string, data: AidRecordUpdateRequest): Promise<AidRecord> {
		const response = await apiClient.patch<SuccessResponse<AidRecord>>(`/aid-records/${id}`, data);
		return response.data.data;
	},

	async remove(id: string): Promise<void> {
		await apiClient.delete(`/aid-records/${id}`);
	},
};
